import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import * as HLF from "html-living-framework";

export class AccessibleLayoutSprite extends LayoutSprite implements HLF.Input.IFocusable {

    public constructor(public hoverVO?: string | string[]) {
        super();
    }

    onFocusBegin(): void {
        this.playHoverVO();
    }
    onFocusEnd(): void {
        //
    }
    onFocusActivated(): void {
        //
    }
    getFocusPosition(): PIXI.Point {
        return HLF.RectUtils.center(HLF.PixiUtils.getGlobalBounds(this));
    }
    getFocusSize(): PIXI.IPoint {
        return HLF.RectUtils.size(HLF.PixiUtils.getGlobalBounds(this));
    }

    protected playHoverVO() {
        if (this.hoverVO) {
            HLF.Application.instance.voiceover.playVO(this.hoverVO);
        }
    }
}